export enum SECTIONS {
    OVERVIEW = 'overviewHeader',
    BONUS = 'bonusHeader',
    ADVANTAGES = 'advantagesHeader',
    ACCOUNT = 'accountHeader',
    NEWSLETTER = 'newsletterHeader',
    HELP = 'helpHeader',
}
